import { combineReducers } from 'redux'
import {
    AudioToTrackReducer,
    userLogin,
    AdminDashBoard,
    PageName,
    UserManagement,
    QAManagement,
    SuperAdminReducer,
    CreatorDashboardReducer 
} from './index'

const AllReducers = combineReducers({
    AudioToTrackReducer,
    userLogin,
    adminDashBoard:AdminDashBoard,
    page: PageName,
    UserManagement,
    QAManagement,
    SuperAdminReducer,
    CreatorDashboardReducer 
});

export default AllReducers;